import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserModel } from '../../models/userModel';
import { FormGroup } from '@angular/forms';
import { AppointmentService } from '../../services/appointment.service';
import { AppointmentReminderDetails, ReminderNumber } from '../../models/reminder';

@Component({
  selector: 'sms-and-call-info-modal',
  templateUrl: './sms-and-call-info-modal.html',
  styleUrls: ['./sms-and-call-info-modal.css'],
})
export class SmsAndCallInfoModal implements OnInit {
  private _reminderData!: AppointmentReminderDetails;

  @Input()
  set reminderData(data: AppointmentReminderDetails) {
    this._reminderData = data;
    this.buildReminderNumbers();
  }
  get reminderData(): AppointmentReminderDetails {
    return this._reminderData;
  }
  @Input() altTitle: string = '';

  // Number(s) the reminder SMS was sent to / the reminder call was placed to, each tagged as primary/secondary
  smsSentNumbers: ReminderNumber[] = [];
  voiceCalledNumbers: ReminderNumber[] = [];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  checkAnsweredBy = (status: string) => {
    switch (status) {
      case 'machine_end_beep':
        return 'Voice Mail';
      case null:
        return 'Not Specified';
      default:
        return status;
    }
  };

  // Colour family for a Twilio SMS / call status badge
  statusClass = (status: string): string => {
    switch ((status || '').toLowerCase()) {
      case 'delivered':
      case 'completed':
      case 'read':
      case 'received':
        return 'ch-badge--success';
      case 'failed':
      case 'undelivered':
      case 'canceled':
        return 'ch-badge--danger';
      case 'busy':
      case 'no-answer':
        return 'ch-badge--warning';
      case 'queued':
      case 'sending':
      case 'sent':
      case 'accepted':
      case 'scheduled':
      case 'ringing':
      case 'in-progress':
        return 'ch-badge--info';
      default:
        return 'ch-badge--muted';
    }
  };

  private buildReminderNumbers(): void {
    this.smsSentNumbers = this.toReminderNumbers(this._reminderData?.smsSentToPhone);
    this.voiceCalledNumbers = this.toReminderNumbers(this._reminderData?.voiceCalledPhone);
  }

  // "5551111111,5552222222" -> [{ number, role: 'primary' | 'secondary' | 'other' }]
  // A number that matches neither current number (e.g. the patient's phone changed since) is tagged 'other'.
  private toReminderNumbers(raw: string | undefined): ReminderNumber[] {
    if (!raw) {
      return [];
    }
    const digits = (value: string) => (value || '').replace(/\D/g, '');
    const primary = digits(this._reminderData?.cellNumber);
    const secondary = digits(this._reminderData?.secondaryCellNumber);

    return raw
      .split(',')
      .map((number) => number.trim())
      .filter((number) => number.length > 0)
      .map((number) => {
        const normalized = digits(number);
        const role = normalized && normalized === primary ? 'primary' : normalized && normalized === secondary ? 'secondary' : 'other';
        return { number, role, label: role === 'primary' ? 'Primary' : role === 'secondary' ? 'Secondary' : 'Other' };
      });
  }
}
